import Vue2 from 'vue/dist/vue.common.js'

import Date from 'Base/Resources/assets/js/plugins/date-plugin'
Vue2.use(Date)

import Api from 'Base/Resources/assets/js/plugins/api-plugin'
Vue2.use(Api)

import UrlGenerator from 'Base/Resources/assets/js/plugins/url-plugin'
Vue2.use(UrlGenerator)

import moment from 'moment'
Vue2.prototype.moment = moment

import store from './vuex/index'

import { UserCan, UserCannot } from 'Base/Resources/assets/js/plugins/acl'
Vue2.use(UserCan, { store: store, abilities: window.UserAbilities })
Vue2.use(UserCannot, { store: store, abilities: window.UserAbilities })

import Slugify from 'Base/Resources/assets/js/plugins/slugify-plugin'
Vue2.use(Slugify)

import UUID from 'vue-uuid'
Vue2.use(UUID)

import VueCookies from 'vue-cookies'
Vue2.use(VueCookies)